// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__Z8UrQ","error":"Textarea_error__1vg1W","readonly":"Textarea_readonly__2RCra","disabled":"Textarea_disabled__xo5B1"};